// extracted by mini-css-extract-plugin
export default {"wrapper":"JXcG7Dvm54ApeIb3iU2j"};